import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import { MDXProvider } from '@mdx-js/react'
import DefaultLink from '../components/DefaultLink'
import ImageCaption from '../components/ImageCaption'
import Callout from '../components/Callout'
import Video from '../components/Video'
import Layout from '../components/Layout'
import ProjectHeroSection from '../components/ProjectHeroSection'
import DifferenceObject from '../components/DifferenceObject'
import device from '../lib/mediaQueries'
import * as colors from '../lib/colors'

const PaddedLayout = styled.div`
  padding: 0px 10% 48px 10%;
  /* text-align: justify; */

  ${device.laptop} {
    padding: 48px 25%;
  }
`

const Image = styled.img`
  position: relative;
  width: 120%;
  left: -10%;
  z-index: 300;
  border-radius: 12px;
  margin-top: 10px;
  margin-bottom: 0px;
  overflow: hidden;
  display: block;
`

const H3 = styled.h3`
  font-size: 18px;
  line-height: 22px;
  margin-top: 50px;
  margin-bottom: 10px;
`

const P = styled.p`
  font-size: 16px;
  line-height: 24px;
  margin-top: 20px;
  margin-bottom: 10px;
`

const LI = styled.li`
  font-size: 16px;
  line-height: 24px;
  margin-top: 20px;
  margin-bottom: 10px;
`

const UL = styled.ul`
  padding-inline-start: 20px;
`
const components = {
  ImageCaption,
  Callout,
  Video,
  wrapper: PaddedLayout,
  a: DefaultLink,
  img: Image,
  h3: H3,
  p: P,
  li: LI,
  ul: UL,
}
const WorkTemplate = ({ data: { mdx } }) => {
  const {
    scheme,
    title,
    featuredImage,
    name,
    description,
    url,
  } = mdx.frontmatter
  const colorScheme = colors[scheme] || colors.main
  const heroRef = React.useRef(null)
  return (
    <Layout
      theme={colorScheme}
      title={name}
      description={title}
      image={featuredImage.childImageSharp.fixed.src}
    >
      <div ref={heroRef}>
        <ProjectHeroSection
          title={title}
          name={name}
          image={featuredImage}
          url={url}
          description={description}
        />
      </div>
      <MDXProvider components={components}>
        <MDXRenderer>{mdx.body}</MDXRenderer>
      </MDXProvider>
      <DifferenceObject avoidRef={heroRef} />
    </Layout>
  )
}

WorkTemplate.propTypes = {
  data: PropTypes.shape,
}

export default WorkTemplate

export const pageQuery = graphql`
  query($id: String) {
    mdx(id: { eq: $id }) {
      id
      body
      frontmatter {
        name
        title
        description
        url
        scheme
        featuredImage {
          childImageSharp {
            fluid(maxWidth: 1000) {
              ...GatsbyImageSharpFluid
            }
            fixed {
              src
            }
          }
        }
      }
    }
  }
`
